import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieBanner } from "../components/CookieBanner";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";

export function Layout() {
  const loc = useLocation();
  useEffect(() => {
    // Scroll to top on route change. Anchored hashes are honored by browser.
    if (!loc.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, [loc.pathname, loc.hash]);
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main id="main" className="flex-1 outline-none" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
